<template>
  <v-card
      class="elevation-2"
  >
    <v-toolbar flat dense outlined>
      <v-toolbar-title class="black--text mt-4 mb-4">
        <v-icon>payments</v-icon>
        Transactions
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text v-if="dailyTransaction">
      <div class="text-h6 font-weight-regular ">
        Daily Total ${{dailySale}}
      </div>
      <v-sheet >
        <v-sparkline
            :value="dailySales"
            color="red"
            line-width="1"
            auto-draw
        ></v-sparkline>
      </v-sheet>
      <div class="font-weight-regular">
        {{todaysSale}}
      </div>
    </v-card-text>
    <v-card-text v-if="weeklyTransactions">
      <div class="text-h6 font-weight-regular ">
        Weekly Total ${{weeklySale}}
      </div>
      <v-sheet >
        <v-sparkline
            :value="weeklySales"
            color="red"
            line-width="1"
            auto-draw
        ></v-sparkline>
      </v-sheet>
      <div class="font-weight-regular">
         {{lastWeekSale}} - {{todaysSale}}
      </div>
    </v-card-text>
    <v-card-text v-if="monthlyTransactions">
      <div class="text-h6 font-weight-regular ">
        Monthly Total ${{monthlySale}}
      </div>
      <v-sheet >
        <v-sparkline
            :value="monthlySales"
            color="red"
            line-width="1"
            auto-draw
        ></v-sparkline>
      </v-sheet>
      <div class="font-weight-regular">
        {{lastMonthSale}} - {{todaysSale}}
      </div>
    </v-card-text>
    <v-card-text v-if="totalTransactions">
      <div class="text-h6 font-weight-regular ">
        All Time Total ${{totalSale}}
      </div>
      <v-sheet >
        <v-sparkline
            :value="totalSales"
            color="red"
            line-width="1"
            auto-draw
        ></v-sparkline>
      </v-sheet>
      <div class="font-weight-regular">
        {{firstSale}} - {{lastSale}}
      </div>
    </v-card-text>
    <v-card-text>
      <div>
        <v-btn outlined text @click="displayGraph('day')">
          day</v-btn>
        <v-btn outlined text @click="displayGraph('week')">
          week</v-btn>
        <v-btn outlined text @click="displayGraph('month')">
          Month</v-btn>
        <v-btn outlined text @click="displayGraph('allTime')">
          All</v-btn>
      </div>
    </v-card-text>



    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn
          block
          text
          @click="$router.push('/transactions')"
      >
        View All
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {collection, onSnapshot} from "firebase/firestore";
import moment from 'moment'
export default {
  data: () => ({
    dailySales: [0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0],
    weeklySales: [0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0],
    totalSales: [0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0],
    monthlySales: [0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0,0, 0, 0],
    sales: undefined,
    totalSale: 0,
    // totalProfit: 0,
    dailySale: 0,
    // dailyProfits: 0,
    weeklySale: 0,
    weeklyProfits: 0,
    monthlySale: 0,
    // monthlyProfit: 0,
    lastSale: "../../..",
    firstSale: "../../..",
    todaysSale: "../../../",
    lastWeekSale: "../../..",
    lastMonthSale: "../../..",
    transactions: [],
    dailyTransaction: true,
    weeklyTransactions: false,
    monthlyTransactions: false,
    totalTransactions: false
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
      this.$store.dispatch('setLoading', true)
      let db = this.$store.state.db
      // fetches transactions associated by this number
      let transactionsRef = collection(db, 'users', this.user.uid + '/transactions')
      onSnapshot(transactionsRef, res => {
        let weekPastToday = Date.now() - 604800 * 1000
        let monthPastToday = Date.now() - 2419200 * 1000
        let dayPastNow = Date.now() - 86400 *1000

        let transactions = []
        let incomingTransactions = []

        let dailySales = []
        let dailySale = 0
        // let dailyProfit = 0

        let weeklySales = []
        let weeklySale = 0
        // let weeklyProfit = 0

        let monthlySales = []
        let monthlySale = 0
        // let monthlyProfit = 0

        let totalSales = []
        let totalSale = 0
        // let totalProfit = 0
        if(!res.empty) {
          res.forEach(doc => {
            let data = doc.data()
            data.id = doc.id
            transactions.push(data)
            // console.log(data)
          })
          let sortedTransactions = transactions.sort((orderA, orderB) => {
            return orderA.created - orderB.created
          })
          sortedTransactions.forEach(data => {
            if (data.direction === 'incoming') {
              incomingTransactions.push(data)
              // console.log(data)
              //setting todays sales
              if(data.created > dayPastNow) {
                dailySale += Number(data.amount)
                dailySales.push(Number(data.amount))
              }
              //setting last weeks sales
              if(data.created > weekPastToday) {
                weeklySale += Number(data.amount)
                weeklySales.push(Number(data.amount))
              }
              //setting last months sale
              if(data.created > monthPastToday) {
                monthlySale += Number(data.amount)
                monthlySales.push(Number(data.amount))
              }
              // setting total values
              totalSales.push(Number(data.amount))
              totalSale += Number(data.amount)

            }
          })

          this.transactions = transactions
          // console.log(this.transactions)
          // this.sales = orders
          //
          if(dailySales.length > 1) {
            // console.log(dailySales)
            this.dailySales = dailySales
          }
          if (dailySales.length === 1) {
            dailySales.push(0)
            this.dailySales = dailySales
          }

          this.dailySale = dailySale.toFixed(2)
          this.todaysSale = moment(dayPastNow).format('ddd, MMM Do')
          if(weeklySales.length > 1) {
            this.weeklySales = weeklySales
          }
          if (weeklySales.length === 1) {
            weeklySales.push(0)
            this.weeklySales = weeklySales
          }
          this.weeklySale = weeklySale.toFixed(2)
          this.lastWeekSale = moment(weekPastToday).format('ddd, MMM Do')

          if(monthlySales.length > 1) {
            this.monthlySales = monthlySales
          }
          if (monthlySales.length === 1) {
            monthlySales.push(0)
            this.monthlySales = monthlySales
          }
          this.monthlySale = monthlySale.toFixed(2)
          this.lastMonthSale = moment(monthPastToday).format('ddd, MMM Do')

          this.totalSales = totalSales
          this.totalSale = totalSale.toFixed(2)

        }
    })
  },
  watch: {
    transactions(sales) {
      let salesCreated = []
      let oldest
      let last
      for (let key in sales) {
        if (sales[key].direction === 'incoming') {
          salesCreated.push(sales[key].created)
        }
      }
      oldest = Math.min(...salesCreated)
      last = Math.max(...salesCreated)
      this.firstSale = moment(oldest).format('ddd, MMM Do YYYY')
      this.lastSale =  moment(last).format('ddd, MMM Do YYYY')
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    displayGraph(graphType) {
      // console.log(graphType)
      if (graphType === 'day') {
        this.dailyTransaction = true
        this.weeklyTransactions = false
        this.monthlyTransactions = false
        this.totalTransactions = false
      }
      if (graphType === 'week') {
        this.dailyTransaction = false
        this.weeklyTransactions = true
        this.monthlyTransactions = false
        this.totalTransactions = false
      }
      if (graphType === 'month') {
        this.dailyTransaction = false
        this.weeklyTransactions = false
        this.monthlyTransactions = true
        this.totalTransactions = false
      }
      if (graphType === 'allTime') {
        this.dailyTransaction = false
        this.weeklyTransactions = false
        this.monthlyTransactions = false
        this.totalTransactions = true
      }
    }
  }

}
</script>

